import { client } from '..';
import { DeleteFavoriteParams, Favorite, FavoritesListResponse, SetFavoriteParams } from '../models/favoritesModels';

export const deleteFavorite = async ({ idFavorite }: DeleteFavoriteParams) => {
  const { data } = await client.delete(`/favorites/${idFavorite}`);

  return data;
};

export const setFavorite = async ({ type, idFavorite }: SetFavoriteParams) => {
  const { data } = await client.post('/favorites', {
    type,
    idFavorite
  });

  return data;
};

export const getFavoritesList = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | number | undefined)[];
  pageParam: string;
}): Promise<FavoritesListResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, n, limit, type] = queryKey;

  const parsedType = type ? `&type=${type}` : '';

  const url = `/favorites/scrolling?n=${pageParam}&limit=${limit}${parsedType}`;

  const { data } = await client.get(url);

  return data;
};

export const getMeFavorites = async (): Promise<Favorite[]> => {
  const url = '/favorites/me';

  const { data } = await client.get(url);

  return data;
};
